var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_203_25107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0543 4.82308H19.3011V0.721247H15.2181C14.8775 0.707075 10.7256 0.627712 9.6495 4.73143C9.63391 4.77442 9.29 5.75039 9.29 8.03019L5.55664 8.04152V12.3436L9.29472 12.3328V23.6803H15.0046V12.3427H18.7838V8.02924H15.0046V6.67204C15.0046 5.82834 15.3603 4.82308 17.0543 4.82308ZM17.839 8.97356V11.3974H14.0598V22.735H10.2395V11.3852L6.50144 11.396V8.98348L10.2494 8.97262L10.2395 8.49219C10.1904 6.07729 10.5348 5.06164 10.5504 5.01298C11.4791 1.4785 15.0254 1.65612 15.1775 1.66557L18.3563 1.66651V3.87875H17.0543C14.8468 3.87875 14.0603 5.32146 14.0603 6.67157V8.97356H17.839Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_25107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.9609,
    height: 22.9609,
    fill: "white",
    transform: "translate(0.949219 0.71875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.7cf8c01a9b26b3ac99a2f53dd2d175be.svg";
export { ForwardRef as ReactComponent };